import { IShortAgency } from "agency/model"
import { translate } from "app/language/service"
import { dateAdd } from "app/util/date/tools/common"
import { messageSVC } from "message/service"
import { HOME_PATH } from "page/model"
import { navigate } from "page/tools/navigate"
import { userEventModule } from "user/event"
import { USER_EVENTS } from "user/model"
import { userRPO } from "user/repository"
import { getUserEmail, getUserInfo, setUserInfo } from "./common"

export const changeAgency = (agency: IShortAgency): Promise<boolean> => {
  return new Promise<boolean>(resolve => {
    if (!agency) {
      return
    }
    messageSVC.confirmMessage({
      title: translate("agency.change.button"),
      message: translate("agency.change.confirm.message"),
      addGenericConfirmMessage: true,
      onSuccess: async () => {
        const changeAgencySession = await userRPO.changeAgencySession(getUserEmail(), agency.id)
        const userInfo = { ...getUserInfo() }
        userInfo.user = {
          ...userInfo.user,
          agency_id: changeAgencySession.agency_id
        }
        userInfo.token = changeAgencySession.session_id
        userInfo.permissions = changeAgencySession.permissions
        userInfo.tokenExpirationDateTime = dateAdd(new Date(), changeAgencySession.ttl, "seconds")
        userEventModule.notify(USER_EVENTS.LOGOUT, {})
        setUserInfo(userInfo, changeAgencySession)
        userEventModule.notify(USER_EVENTS.LOGIN, { userInfo })
        navigate(HOME_PATH)
        resolve(true)
      },
      onCancel: () => resolve(false)
    })
  })
}
